module.exports = __webpack_public_path__ + "static/MANIFESTO-4384906ae4f836ed140a5fbf2b846318.svg";